import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
// import store
import { store } from './Store/store';
import Routes from './Routes/routes';
import CacheBuster from './CacheBuster';
import './styles/app.css';


export default class App extends React.Component {
  render() {
    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            // You can decide how and when you want to force reload
            refreshCacheAndReload();
          }
          return (
            <Provider store={store}>
              <Router>
                <Routes {...this.props} />
              </Router>
            </Provider>
          );
        }}
      </CacheBuster>
    );
  }
}
